import { render, staticRenderFns } from "./index.vue?vue&type=template&id=19a0a4da&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=19a0a4da&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a0a4da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\aihuz\\arbitration-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19a0a4da')) {
      api.createRecord('19a0a4da', component.options)
    } else {
      api.reload('19a0a4da', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=19a0a4da&scoped=true&", function () {
      api.rerender('19a0a4da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/case/platformPreview/index.vue"
export default component.exports